import React, { useCallback } from 'react';
import { Button } from 'components';
import { useBoolModalState } from '@app/core';
import { ProspectCreationModal } from './ProspectCreationModal';
import {
  ProspectActionEnum,
  Prospect,
  StudySetupInfo,
  useAddActionToProspect,
} from 'queries';
import { GoogleAppointmentModal } from 'components/GoogleCalendar/GoogleAppointmentModal';
import { G_CALENDAR_LINK } from 'components/GoogleCalendar/gCalendar';

interface Props {
  text: string;
  modalTitle: string;
  modalDescription?: string;
  submitText: string;
  action: ProspectActionEnum;
  studySetupInfo: StudySetupInfo;
}

export const BookWithSalesButton = (props: Props) => {
  const [isOpen, open, close] = useBoolModalState();
  const [
    appointmentModalIsOpened,
    openAppointmentModal,
    closeAppointmentModal,
  ] = useBoolModalState(false);
  const { mutateAsync: addActionToProspect } = useAddActionToProspect();

  const { action, studySetupInfo } = props;
  const onProspectCreated = useCallback(
    async (prospect: Prospect) => {
      close();
      let quoteId: string | undefined = undefined;
      await addActionToProspect({
        action,
        studySetupInfo,
        quoteId,
        prospectId: prospect.id,
      });

      openAppointmentModal();
    },
    [close, addActionToProspect, action, studySetupInfo, openAppointmentModal],
  );

  return (
    <>
      <Button type="button" onClick={open} text={props.text} color="accent" />
      <ProspectCreationModal
        isOpen={isOpen}
        onRequestClose={close}
        onProspectCreated={onProspectCreated}
        title={props.modalTitle}
        description={props.modalDescription}
        submitText={props.submitText}
        action={action}
      />
      <GoogleAppointmentModal
        isOpen={appointmentModalIsOpened}
        onRequestClose={closeAppointmentModal}
        calendarUrl={G_CALENDAR_LINK}
      />
    </>
  );
};
